export function sameTagSet(left = [], right = []) {
  if (left.length !== right.length) return false
  const rightSet = new Set(right)
  return left.every((id) => rightSet.has(id))
}

// A regulation's content starts as a copy of the shared post, so an override
// opens pre-filled with the caption and tags chosen in the main flow. The
// operator edits down from there rather than starting empty.
export function buildRegulationOverride(sharedText, sharedTagIds) {
  return { text: sharedText || '', tagIds: [...(sharedTagIds || [])] }
}

// Only differences are worth forking for. An override that still matches the
// shared post would create a variant that diverges from nothing, and which
// then silently stops receiving shared edits.
export function regulationOverrideDiffers(override, sharedText, sharedTagIds) {
  if (!override) return false
  return (override.text || '') !== (sharedText || '')
    || !sameTagSet(override.tagIds || [], sharedTagIds || [])
}
